import { api } from "../scripts/api";

export function getSurveys(userTypeId, userId, callback) {
  api.post(
    `/_vti_bin/Servicios/ServicioTransarSurvey.svc/GetUserBasicDataSurveysl`,
    {
      userTypeId,
      userId,
    }
  ).then((response) => {
    let data;
    if (response.data) {
      data = response.data.GetUserBasicDataSurveyslResult
    }
    if (!data) {
      this.getErrorMessage(
        data.ResponseDetail,
        "Cerrar",
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.False"
        ),
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.True"
        )
      );
      this.setState({ error: true });
      compensar.quitarLoading("#Landing-Encuestas");
    }
    if (data.ResponseCode === 200 && data.Result.ConsultarAfiliadoOut) {
      // if (data.Result.AffiliatedHasAccess === true) {
      //     this.setState({
      //         responseAccess: data.Result.AffiliatedHasAccess
      //     });
      //     this.dataIsLogged();
      // } else {
      //     this.setState({
      //         responseAccess: data.Result.AffiliatedHasAccess
      //     });
      //     compensar.quitarLoading('.selectorPadre');
      // }
      const programaAccess = data.Result.ConsultarAfiliadoOut.pROGRAMA.filter(el => el.IndicadorPrestacion === 'S')
      // Si hay un elemento con IndicadorPrestacion en S, entonces tiene acceso
      if (programaAccess.length > 0) {
        api.post(
          `/_vti_bin/Servicios/ServicioTransarSurvey.svc/GetSurveyssl`,
          {
            userTypeId,
            userId,
          }
        ).then(({ data }) => {
          let response = data;
          if (response.ResponseCode === 200) {
            const hasBeneficiaries = response.Result.filter((item) => {
              return item.IsContributor === true;
            });
            if (hasBeneficiaries.length === 0) {
              if (response.Result[0].SurveysList.length !== 0) {
                response.Result[0].SurveysList.sort((survey1, survey2) => {
                  return survey2.ID - survey1.ID;
                });
                this.handleSubmitFinish({
                  surveys: response.Result,
                  userInfo: {
                    userTypeId,
                    userId,
                  },
                });
              }
            } else {
              if (response.Result.length > 0) {
                if (response.Result[0].SurveysList.length !== 0) {
                  response.Result[0].SurveysList.sort((survey1, survey2) => {
                    return survey2.ID - survey1.ID;
                  });
                }
              }
              this.handleSubmitFinish({
                surveys: response.Result,
                userInfo: {
                  userTypeId,
                  userId,
                },
              });
            }
      
            compensar.quitarLoading("#Landing-Encuestas");
          } else if (response.ResponseCode === 500 || response.ResponseCode === 450) {
            this.getErrorMessage(
              response.ResponseDetail,
              "Cerrar",
              sharedResources.getResource(
                "es",
                "nsGeneralResources",
                "Modal.Bolean.False"
              ),
              sharedResources.getResource(
                "es",
                "nsGeneralResources",
                "Modal.Bolean.True"
              )
            );
            this.setState({ error: true });
            compensar.quitarLoading("#Landing-Encuestas");
          } else if (response.ResponseCode === 430) {
            this.getErrorMessage(
              response.ResponseDetail,
              "Cancelar",
              sharedResources.getResource(
                "es",
                "nsGeneralResources",
                "Modal.Bolean.False"
              ),
              sharedResources.getResource(
                "es",
                "nsGeneralResources",
                "Modal.Bolean.True"
              )
            );
            compensar.quitarLoading("#Landing-Encuestas");
          }
          callback(userTypeId, userId)
        })
      } else {
        this.getErrorMessage(
          "Lo sentimos, no tiene acceso.",
          "Cerrar",
          sharedResources.getResource(
            "es",
            "nsGeneralResources",
            "Modal.Bolean.False"
          ),
          sharedResources.getResource(
            "es",
            "nsGeneralResources",
            "Modal.Bolean.True"
          )
        );
      }

    } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
      this.getErrorMessage(
        data.ResponseDetail,
        "Cerrar",
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.False"
        ),
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.True"
        )
      );
      this.setState({ error: true });
      compensar.quitarLoading("#Landing-Encuestas");
    } else if (data.ResponseCode === 430) {
      this.getErrorMessage(
        data.ResponseDetail,
        "Cancelar",
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.False"
        ),
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.True"
        )
      );
      compensar.quitarLoading("#Landing-Encuestas");
    }
  });
}